export const formSolicitacao = {
  cnpj: '',
  email: '',
  endereco: '',
  nomeEmpresa: '',
  prepostoEmpresa: '',
  telefone: '',
  tipoSolicitacao: '',
  arquivos: [],
};

export const documentosPorRegra = {};

export const documentacaoPorTipoSolicitacao = {};

export const recaptcha = null;

export const possuiSolicitacaoEmAndamento = false;

export const possuiAutorizacaoConsumidorCativo = false;

export const solicitacaoPreAprovada = [];